import { LOCALES } from 'constants/locales'

const storedLocale = window.localStorage.getItem('locale')

const fromNavigatorLanguage = language => {
  if (/^zh-(Hant|TW|HK|MO)\b/i.test(language)) return 'zh_Hant'
  if (/^zh\b/i.test(language)) return 'zh_Hans'
  return language.substr(0, 2)
}

export const defaultLocale =
  storedLocale || fromNavigatorLanguage(window.navigator.language || window.navigator.userLanguage || 'fr')

/**
 * Get locale from location pathname: '/:lang/some-route'
 * If none is found, use navigator default
 */
export function getDefaultLocale() {
  const match = /\/([^/]+)/.exec(window.location.pathname)
  const lang = match?.[1]
  return lang && LOCALES.includes(lang) ? lang : defaultLocale
}
